import { Button, Dialog } from '@mui/material'
import React, { useEffect, useState } from 'react'
import useAuth from '../../../components/hooks/useAuth'
import { useTheme } from '../../../components/hooks/useTheme'
import useDelete from '../../../components/hooks/useDelete';
import { delete_PaymentRequest } from '../../../services/PaymentRequest';
import { paymentRequestStatusColorCode } from '../../../utils/statusColorCode';
import colorConfigs from '../../../configs/colorConfigs';
import Cookies from 'js-cookie';
import useTenant from '../../../components/hooks/useTenant';
import useGeneral from '../../../components/hooks/useGeneral';
import moment from 'moment';

type PaymentRequestDetailsProps = {
    open: boolean;
    onClose: () => void;
    setPleaseWait: (value: boolean) => void;
    isCompletedOrCancelled: boolean;
    paymentRequestDetails: any;
    refreshThePaymentRequest: () => void;
}

const PaymentRequestDetails = ({
    open,
    onClose,
    setPleaseWait,
    isCompletedOrCancelled,
    paymentRequestDetails,
    refreshThePaymentRequest
}: PaymentRequestDetailsProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { dateFormat }: any = useGeneral();
    const { theme, themeStyles } = useTheme();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    const [statusColor, setStatusColor] = useState<any | null>({
        colorBg: "#000000",
        colorText: "#000000"
    });

    useEffect(() => {
        if (paymentRequestDetails) {
            let colorObj = paymentRequestStatusColorCode?.find((color: any) => color?.label === paymentRequestDetails?.status?.trim()?.toLowerCase())
                || {
                colorBg: "#000000",
                colorText: "#000000"
            };

            setStatusColor(colorObj);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentRequestDetails])

    const deleteThePaymenRequest = () => {
        if (!isCompletedOrCancelled) {
            setDeleteData({
                id: paymentRequestDetails?.id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this Payment Request?`,
                isDelete: async (callback: any) => {
                    callback();

                    setPleaseWait(true);

                    await delete_PaymentRequest(paymentRequestDetails?.id, auth?.id, tenantId)
                        .then(() => {
                            onClose();
                            refreshThePaymentRequest();
                            setPleaseWait(false);
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            setPleaseWait(false);
                            handleTenantError(error);
                        });
                }
            });

            setDeletePopup(true);
        }
    }

    return (
        <>
            <Dialog
                open={open}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '600px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => onClose()}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>{`Request ${paymentRequestDetails?.requestType || "Payment"}`}</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div>
                                            <div className="flex flex-col gap-y-[0.5rem]">
                                                <div>
                                                    <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Amount</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>${parseFloat(paymentRequestDetails?.amount)?.toFixed(2) || 0.00}</span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Email</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{paymentRequestDetails?.email || "--"}</span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Due Date</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                                                                {
                                                                    paymentRequestDetails?.dueDate
                                                                        ? moment(
                                                                            new Date(
                                                                                paymentRequestDetails?.dueDate
                                                                                    ?.replaceAll("-", "/")
                                                                                    ?.split("T")[0]
                                                                            )
                                                                        ).format(dateFormat)
                                                                        : "--"
                                                                }
                                                            </span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Status</label>
                                                            <span className={`w-fit text-xs font-medium px-[10px] py-[2px] rounded-xl border ${themeStyles.main.borderColor} ${statusColor?.colorText} ${statusColor?.colorBg}`}>
                                                                {paymentRequestDetails?.status || "--"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-4 mt-6">
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={onClose}
                                                >
                                                    Cancel
                                                </Button>

                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.delete.bg
                                                    }}
                                                    onClick={deleteThePaymenRequest}
                                                    disabled={isCompletedOrCancelled}
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default PaymentRequestDetails